import request from '@/utils/request'

export function getInvoiceList (query) {
  return request({
    url: '/api/merchant/invoice/list',
    method: 'get',
    params: query
  })
}

export function getInvoiceDetail (query) {
  return request({
    url: '/api/merchant/invoice/detail',
    method: 'get',
    params: query
  })
}

export function getReceiveList () {
  return request({
    url: '/api/merchant/invoice/receive-list',
    method: 'get'
  })
}

export function getInvoiceCitys () {
  return request({
    url: '/api/merchant/invoice/citys',
    method: 'get'
  })
}

export function addReceive (query) {
  return request({
    url: '/api/merchant/invoice/add-receive',
    method: 'post',
    data: query
  })
}

export function updateReceive (query) {
  return request({
    url: '/api/merchant/invoice/update-receive',
    method: 'post',
    data: query
  })
}

export function deleteReceive (query) {
  return request({
    url: '/api/merchant/invoice/delete-receive',
    method: 'post',
    data: query
  })
}

export function addInvoiceInfo (query) {
  return request({
    url: '/api/merchant/invoice/addinfo',
    method: 'post',
    data: query
  })
}

export function updateInvoiceInfo (query) {
  return request({
    url: '/api/merchant/invoice/updateinfo',
    method: 'post',
    data: query
  })
}

export function getInvoiceInfo (query) {
  return request({
    url: '/api/merchant/invoice/infodetail',
    method: 'get',
    params: query
  })
}

export function invoiceSubmit (query) {
  return request({
    url: '/api/merchant/invoice/submit',
    method: 'post',
    data: query
  })
}

export function getInfodetail (query) {
  return request({
    url: '/api/merchant/invoice/infodetail',
    method: 'get',
    params: query
  })
}

export function getDefaultReceive (query) {
  return request({
    url: '/api/merchant/invoice/default-receive',
    method: 'post',
    data: query
  })
}

export function alipay (query) {
  return request({
    url: '/api/merchant/pay/wap/alipay',
    method: 'post',
    data: query
  })
}

export function editRemark (query) {
  return request({
    url: '/api/merchant/invoice/remark',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/services/invoice.js